<template>
  <div>
    <button
      type="button"
      class="btn btn-lg btn-primary mr-3"
      @click="openAddProviderModal"
    >
      Send Trigger
    </button>
    <Modal
      id="triggerReset"
      title="Trigger Password Reset"
      :toggle="closeModal"
      :loading="loading"
    >
      <h3>Are you sure you want to send trigger</h3>
      <p>
        This would send a trigger for a password reset, are you sure you want to
        continue?
      </p>
      <form @submit.prevent="triggerReset">
        <FormButtons
          :loading="loading"
          :handleCloseModal="closeModal"
          :closeBtnName="`No, Don't Send Trigger`"
          :btnName="`Yes, Send Trigger`"
        />
      </form>
    </Modal>
  </div>
</template>

<script>
import { notifications } from "../../../../../../../public/assets/mixins/notifications";
import Modal from "../../../../../../components/utils/Modal/Modal";
import FormButtons from "../../../../../../components/utils/FormButtons/FormButtons";
import CustomInput from "../../../../../../components/utils/CustomInput/CustomInput.vue";
import CustomSelect from "../../../../../../components/utils/CustomSelect/CustomSelect";

export default {
  mixins: [notifications],
  name: "PasswordResetModal",
  data() {
    return {
      loading: false,
    };
  },
  props: ["teamInformation"],
  methods: {
    openAddProviderModal() {
      $("#triggerReset").modal("show");
    },
    closeModal() {
      $("#triggerReset").modal("hide");
    },
    async triggerReset() {
      try {
        this.loading = true;
        let response = await this.$store.dispatch(
          "customer/triggerPasswordReset",
          {
            id: this.teamInformation.user_id,
            clientid: this.$route.params.clientid,
          }
        );
        console.log({ response });
        this.loading = false;
        this.closeModal();
        this.showSuccessNotification(response.message);
      } catch (error) {
        this.loading = false;
        this.showErrorNotification(error?.message);
      }
    },
  },
  components: {
    Modal,
    FormButtons,
    CustomInput,
    CustomSelect,
  },
};
</script>
